/* ==========================================================================
   GSJ — BUY IT NOW keeps the cart and the reward.

   The EComposer buy-it-now button is a plain <button> with a target-phase click
   listener of its own that reads the live variant/quantity out of the product
   form and then does:

       location.href = '/cart/<variant>:<qty>'

   That is a Shopify cart PERMALINK, and it does two damaging things, both
   reproduced on the live store: it redirects straight to /checkouts/cn/... so
   the cart reward ladder never gets a chance to apply its code (the $270 hoops
   reach checkout at $270 instead of $250), and it REPLACES the cart, so a $95
   chain already in the bag is silently dropped.

   This listener runs on document in the CAPTURE phase, so it reaches the click
   before EComposer's own target-phase listener; stopImmediatePropagation then
   keeps that listener from ever running. The add goes through /cart/add.js, the
   drawer's own reward routine is awaited, and then:

     - cart was empty before the click  -> straight to checkout, as before
     - cart already held something      -> open the drawer instead, so the
                                           shopper sees everything they are
                                           about to buy rather than losing it

   Any failure falls back to the original permalink, so the button never dies.
   Nothing about how it looks changes.

   Deliberately NOT placed inside the EComposer section: that file is
   regenerated whenever the page is re-saved in the EComposer editor.
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '.ecom-product-single__buy_it_now_btn--checkout';
  var BUSY = 'gsj-buy-now-busy';

  function productForm(btn) {
    /* The form EComposer itself reads, so the variant matches what the shopper
       has actually selected rather than whatever was rendered at page load. */
    var scope = btn.closest('.ecom-product-single') || btn.closest('form') || document;
    return scope.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('form[action*="/cart/add"]');
  }

  function readVariant(btn) {
    var form = productForm(btn);
    if (form) {
      var input = form.querySelector('select[name="id"], input[name="id"]');
      if (input && input.value) return String(input.value);
    }
    var loose = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (loose && loose.value) return String(loose.value);
    /* Last resort: the id baked into the button at render time. */
    return btn.getAttribute('data-variant-id') || '';
  }

  function readQty(btn) {
    var form = productForm(btn);
    var q = form && form.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function permalink(variant, qty) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart/' + variant + ':' + qty;
  }

  function cartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c && c.item_count ? c.item_count : 0; })
      .catch(function () { return null; }); // null = unknown
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!btn) return;

    var cart = window.GSCartInstance;
    var variant = readVariant(btn);
    /* Without the drawer's instance or a variant id there is nothing to improve
       on, so let EComposer do exactly what it always did. */
    if (!cart || !variant) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (btn.classList.contains(BUSY)) return;
    btn.classList.add(BUSY);

    var qty = readQty(btn);
    var fellBack = false;
    function fallback() {
      if (fellBack) return;
      fellBack = true;
      window.location.href = permalink(variant, qty);
    }
    /* If anything stalls, the shopper still gets the original behaviour rather
       than a dead button. */
    var guard = setTimeout(fallback, 6000);

    cartCount().then(function (before) {
      return cart.addVariant(variant, qty).then(function (data) {
        var section = data && data.sections ? data.sections[cart.cfg.rewardSectionId] : null;
        /* The same routine the drawer uses, awaited — this is the whole point:
           the reward code has to be on the cart before we leave the page. */
        return cart.settleReward(section).then(function () {
          clearTimeout(guard);
          if (fellBack) return;
          if (before === 0) {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root.replace(/\/$/, '') : '') + '/checkout';
            return;
          }
          /* Something else was already in the bag (or we could not tell), so
             show it rather than risk checking out with a surprise. */
          return cart.refresh().then(function () {
            if (section) cart.swapRewardBlock(section);
            cart.publishUpdate();
            cart.openCart(btn);
            btn.classList.remove(BUSY);
          });
        });
      });
    }).catch(function () {
      clearTimeout(guard);
      btn.classList.remove(BUSY);
      fallback();
    });
  }, true); // capture — must beat EComposer's own listener
})();
